import { isObject } from 'lodash';

import { MagistralDrug, MagistralDrugCreateCommand } from '@dreryk/drerykweb-medicine-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { magistralDrugTranslationKeys } from '../../../../translations';
import { getMaterialUnit } from '../../prescriptionTemplates/magistralDrug/modal/MagistralDrugTemplatesCommand.utils';

import {
   MagistralDrugCreateFormBean,
   MagistralDrugCreateFormController,
   OnMagistralDrugCreated,
} from './MagistralDrugCreateForm.types';

type MagistralDrugCreateActionProps = Pick<MagistralDrugCreateFormController, 'handleSubmit' | 'reset'> & {
   readonly onMagistralDrugCreated: OnMagistralDrugCreated;
   readonly onClose: VoidFunction;
};

export const MagistralDrugCreateAction = (props: MagistralDrugCreateActionProps): JSX.Element => {
   const { executeAsync: createMagistralDrug } = useCqrsCommand<MagistralDrug, MagistralDrugCreateFormBean>(
      (parameters) => {
         const command = new MagistralDrugCreateCommand();
         command.name = Choice.withUseDefaultIfNull(parameters.drugName ?? null);
         command.form = parameters.drugForm!;
         command.additionalDetails = Choice.withUseDefaultIfNull(parameters.additionalDetails ?? null);
         command.magistralDrugMedicineRawMaterials = parameters.medicineRawMaterials.map((material) => {
            return {
               name: isObject(material.name) ? material.name.nameForPrescription : material.name,
               rpw: material.rpw,
               quantity: material.quantity ?? undefined,
               quantityUnit: getMaterialUnit(material.quantity, material.unit),
               quantityAbbreviation: material.quantityAbbreviation ?? undefined,
               highDoseAlert: material.excessive,
               csiozCode: isObject(material.name) ? material.name.csiozCode : undefined,
               eanCode: isObject(material.name) ? material.name.eanCode : undefined,
            };
         });

         return command;
      },
      {
         onSuccess: (magistralDrug) => {
            props.onMagistralDrugCreated(magistralDrug);
            props.reset();
            props.onClose();
         },
      }
   );

   return (
      <ModalConfirmButton
         testId={'addToPrescription'}
         label={magistralDrugTranslationKeys.addToPrescription}
         onClick={props.handleSubmit(createMagistralDrug)}
      />
   );
};
